{
  "status": {
    "DRAFT": "مسودة",
    "POSTED": "مرحّل",
    "VOID": "مُبطَل"
  },
  "payment": {
    "UNPAID": "غير مدفوعة",
    "PARTIAL": "مدفوعة جزئيًا",
    "PAID": "مدفوعة",
    "OVERDUE": "متأخرة",
    "days_zero": "{{count}} يوم",
    "days_one": "يوم واحد",
    "days_two": "يومان",
    "days_few": "{{count}} أيام",
    "days_many": "{{count}} يومًا",
    "days_other": "{{count}} يوم"
  },
  "kind": {
    "INVOICE": "فاتورة",
    "DEBIT_NOTE": "إشعار مدين"
  },
  "fields": {
    "customer": "العميل",
    "reference": "المرجع",
    "notes": "ملاحظات",
    "number": "الرقم",
    "kind": "النوع",
    "date": "التاريخ",
    "total": "الإجمالي",
    "status": "الحالة",
    "journalEntry": "القيد اليومي",
    "viewEntry": "عرض القيد اليومي",
    "posted": "مرحّل",
    "notPostedYet": "لم يُرحَّل بعد",
    "noEntry": "لا يوجد (مُبطَل)",
    "updatedAt": "آخر تعديل"
  },
  "list": {
    "clearSearch": "مسح البحث",
    "emptyFiltered": "لا شيء يطابق عوامل التصفية هذه.",
    "emptyFilteredBody": "جرّب بحثًا أو عميلًا أو فترة أخرى.",
    "clearFilters": "مسح عوامل التصفية",
    "customerFilter": "التصفية حسب العميل",
    "allCustomers": "جميع العملاء",
    "statusFilter": "التصفية حسب الحالة",
    "allStatuses": "جميع الحالات"
  },
  "form": {
    "saveHint": "اضغط {{shortcut}} للحفظ",
    "shortcuts": "{{save}} للحفظ · {{second}}: {{label}}"
  },
  "leave": {
    "title": "تجاهل التغييرات غير المحفوظة؟",
    "body": "لديك تغييرات في هذه الصفحة لم تُحفظ بعد.",
    "confirm": "تجاهل التغييرات",
    "cancel": "متابعة التعديل"
  },
  "conflict": {
    "title": "عدّل شخص آخر هذا المستند",
    "body": "لم تُحفظ تغييراتك. أعد التحميل لرؤية أحدث نسخة، ثم أعد إجراء تغييراتك.",
    "reload": "إعادة التحميل"
  },
  "creditInFull": {
    "action": "إشعار دائن كامل",
    "actionMenu": "إشعار دائن كامل…",
    "title": "إصدار إشعار دائن كامل للفاتورة {{number}}؟",
    "body": "يُصدر إشعار دائن بتاريخ اليوم يستردّ كل ما لم يُستردّ بعد من هذه الفاتورة. تبقى الفاتورة وفترتها كما هما.",
    "dated": "إشعار دائن بتاريخ {{date}}",
    "loading": "جارٍ إعداد الإشعار الدائن…",
    "linesTitle": "المُرتجع",
    "serials": "الأرقام التسلسلية: {{serials}}",
    "total": "إجمالي الإشعار الدائن",
    "applied": "مقابل الرصيد المستحق",
    "paidPart": "ما دفعه العميل",
    "refundNow": "ردّ المبلغ المدفوع الآن",
    "keptAsCredit": "يبقى المبلغ المدفوع رصيدًا للعميل، يُطبَّق على فاتورة أخرى أو يُردّ لاحقًا.",
    "walkInTitle": "يُردّ المبلغ المدفوع الآن",
    "walkInBody": "لا يحتفظ العميل النقدي برصيد، لذا يُردّ ما دُفع في هذه الخطوة. الأفضل إرجاع بيع نقطة البيع من نقطة البيع.",
    "walkInNoRight": "لا يحتفظ العميل النقدي برصيد، لذا يجب ردّ ما دُفع في هذه الخطوة، وليست لديك صلاحية إنشاء المبالغ المردودة. أرجِع البيع من نقطة البيع، أو اطلب ذلك ممن يملك الصلاحية.",
    "periodTitle": "فترة اليوم مغلقة أمام الترحيل",
    "periodBody": "لا يمكن ترحيل أي شيء بتاريخ {{date}}، لذا لا يمكن إصدار الإشعار الدائن اليوم. اطلب من محاسبك فتح الفترة.",
    "confirm": "إصدار إشعار دائن كامل",
    "toast": "رُحّل الإشعار الدائن {{number}}",
    "toastRefunded": "رُحّل الإشعار الدائن {{number}} وأُنشئ المبلغ المردود {{refund}}",
    "voidHintTitle": "الإلغاء يغيّر فترة سابقة",
    "voidHintEarlier": "هذه الفاتورة بتاريخ {{date}}. إلغاؤها يعكسها في ذلك التاريخ، فتتغير أرقام تلك الفترة (ومنها ضريبة القيمة المضافة). أما الإشعار الدائن الكامل فيُرحَّل بتاريخ اليوم.",
    "voidHintLocked": "فترة هذه الفاتورة مقفلة أو مغلقة، لذا لا يمكن إلغاؤها. أما الإشعار الدائن الكامل فيُرحَّل بتاريخ اليوم.",
    "voidHintAction": "إصدار إشعار دائن كامل بدلًا من ذلك"
  },
  "errors": {
    "NOTHING_TO_CREDIT": "استُردّ كل ما في هذه الفاتورة من قبل.",
    "CREDIT_IN_FULL_AFTER_ALLOWANCE": "صدر خصم مقابل هذه الفاتورة، لذا فإن إرجاع كل شيء يتجاوز ما تبقى. استرد الباقي بإشعار إرجاع، أو ألغِ الخصم أولًا.",
    "SERIALS_UNTRACEABLE": "تعذّر ربط بعض الوحدات ذات الأرقام التسلسلية بهذا البيع. أرجِعها بإشعار دائن يذكر أرقامها التسلسلية.",
    "WALK_IN_NO_CREDIT_FULL": "لا يحتفظ العميل النقدي برصيد: ردّ المبلغ المدفوع في الخطوة نفسها، أو أرجِع البيع من نقطة البيع.",
    "PROJECT_DOCUMENT": "هذا المستند تابع لمشروع: أبطِله أو صحّحه من المشروع.",
    "QUOTATION_STARTED_PROJECT": "بدأ عرض السعر هذا مشروعًا: فوتره من المشروع.",
    "PROJECT_CUSTOMER_MISMATCH": "المشروع لعميل آخر: اختر مشروعًا لهذا العميل أو اتركه فارغًا.",
    "notSaved": "لم يُحفظ",
    "field": "تحقّق من هذه القيمة.",
    "INSUFFICIENT_STOCK": "المخزون لا يكفي: تمنع سياسة المخزون المبيعات التي تُنزل المخزون إلى ما دون الصفر.",
    "INSUFFICIENT_STOCK_INVENTORY_OFF": "المخزون لا يكفي: تمنع سياسة المخزون المبيعات التي تُنزل المخزون إلى ما دون الصفر. وحدة المخزون متوقفة لشركتك، فلا يمكن تحويل المخزون أو جرده: خفّض الكميات، أو اطلب من المسؤول تغيير سياسة المخزون في الإعدادات › المخزون.",
    "INVOICE_POSTED": "لا يمكن تعديل أو حذف إلا المسودات. الفاتورة المرحّلة يمكن إبطالها فقط.",
    "INVOICE_NOT_POSTED": "لا يمكن إبطال فاتورة أو إصدار إشعار دائن عليها إلا بعد ترحيلها.",
    "INVOICE_HAS_CREDIT_NOTES": "صدرت إشعارات دائنة على هذه الفاتورة. أبطِلها أولًا.",
    "INVOICE_HAS_PAYMENTS": "هناك سندات قبض أو إشعارات دائنة مطبّقة على هذه الفاتورة. أزلها عنها أولًا.",
    "CUSTOMER_ARCHIVED": "هذا العميل مؤرشف. استعِد العميل أولًا.",
    "CUSTOMER_INACTIVE": "هذا العميل غير نشط، فلا يمكن إصدار فواتير أو إشعارات مدينة أو عروض أسعار له. أعد تنشيط العميل أولًا أو اختر عميلًا آخر.",
    "ALLOCATION_EXCEEDS_BALANCE": "أحد المبالغ أكبر من المتبقي على فاتورته.",
    "ALLOCATION_EXCEEDS_RECEIPT": "مجموع المبالغ أكبر من المتبقي في سند القبض هذا.",
    "ALLOCATION_EXCEEDS_CREDIT": "مجموع المبالغ أكبر من المتبقي في هذا الإشعار الدائن.",
    "QUOTATION_NOT_PENDING": "لا يمكن اعتماد أو رفض أو حذف إلا عرض سعر قيد الانتظار.",
    "QUOTATION_NOT_EDITABLE": "لا يمكن تعديل إلا عرض سعر قيد الانتظار أو مرفوض.",
    "QUOTATION_NOT_APPROVED": "لا يمكن تحويل عرض السعر إلى فاتورة إلا بعد اعتماده.",
    "QUOTATION_EXPIRED": "انتهت صلاحية عرض السعر هذا. أكّد أنك تريد تحويله رغم ذلك.",
    "CREDIT_NOTE_POSTED": "لا يمكن تعديل أو ترحيل أو حذف إلا مسودة إشعار دائن.",
    "CREDIT_NOTE_NOT_POSTED": "لا يمكن إبطال أو تطبيق إلا إشعار دائن مرحّل.",
    "CREDIT_EXCEEDS_INVOICE": "المبلغ الدائن أكبر من المتبقي القابل للإشعار على الفاتورة.",
    "RETURN_EXCEEDS_SOLD": "إحدى الكميات أكبر مما يمكن إرجاعه من الفاتورة.",
    "NO_MAIN_WAREHOUSE": "لم يُحدَّد مستودع رئيسي. اطلب من المسؤول اختياره من المخزون › المستودعات.",
    "WHOLE_UNITS_ONLY": "منتج يُعدّ بوحدات كاملة كُتبت كميته بكسور.",
    "SOURCE_REFUNDED": "استرد العميل جزءًا من هذا المبلغ. أبطِل الاسترداد أولًا.",
    "TILL_DOCUMENT": "هذا المستند صادر من نقطة البيع، لذا لا يُبطَل إلا منها: أبطِل عملية البيع في نقطة البيع ما دامت ورديتها مفتوحة.",
    "WALK_IN_NO_CREDIT": "لا يحتفظ العميل النقدي برصيد، لذا لا يمكن إزالة هذه التسوية.",
    "WALK_IN_NO_CREDIT_POST": "لا يحتفظ العميل النقدي برصيد، لذا لا يمكن ترحيل هذا الإشعار الدائن. أجرِ الإرجاع في نقطة البيع، فهي تردّ المبلغ فورًا.",
    "WALK_IN_NO_CREDIT_POST_POS_OFF": "لا يحتفظ العميل النقدي برصيد، لذا لا يمكن ترحيل هذا الإشعار الدائن. تُجرى مرتجعات المبيعات النقدية في نقطة البيع، وهي متوقفة لشركتك: أعِد تشغيلها لإرجاع هذا البيع.",
    "SERIAL_COUNT_MISMATCH": "يحتاج البند ذو الأرقام التسلسلية إلى كمية صحيحة ورقم تسلسلي لكل وحدة. عدّل المسودة لاختيارها.",
    "SERIAL_NOT_AVAILABLE": "لا يمكن استخدام أحد الأرقام التسلسلية هنا: بيع أو نُقل أو أُرجع منذ ذلك الحين. عدّل المسودة لاختيار غيره.",
    "SERIAL_DUPLICATE": "أحد الأرقام التسلسلية مكرر، أو موجود في المخزون بالفعل.",
    "SERIALS_NOT_TRACKED": "أُدخلت أرقام تسلسلية لمنتج لا يتتبعها.",
    "SERIAL_MOVED_ON": "تغيّر وضع أحد الأرقام التسلسلية في هذا المستند منذ ذلك الحين (بيع أو أُرجع أو نُقل)، لذا لا يمكن التراجع عنه.",
    "STOCK_ALREADY_USED": "بيع بعض البضائع التي أعادها هذا المرتجع أو نُقل منذ ذلك الحين، لذا لا يمكن إبطاله.",
    "RETURN_SHARE_TOO_SMALL": "أرجع هذا البند بكميات أكبر: مبالغ الوحدة الواحدة أقل من بيسة واحدة.",
    "DRAFT_OUTDATED": "تغيّر شيء في هذه المسودة منذ حفظها (منتج أو نسبة ضريبة). عدّل المسودة واحفظها مرة أخرى، ثم رحّلها.",
    "CHEQUE_CLEARED": "صرف البنك شيك هذا السند. تراجع عن صرف الشيك أولًا.",
    "WAREHOUSE_ARCHIVED": "المستودع الذي ستعود إليه البضاعة مؤرشف. استعِده من المخزون › المستودعات قبل إبطال هذه الفاتورة.",
    "PRODUCT_ARCHIVED": "أحد منتجات هذا المرتجع مؤرشف، فستعود البضاعة إلى حيث لا يمكن بيعها أو تسويتها. استعِد المنتج قبل استرجاعها.",
    "CHEQUE_NOT_CLEARED": "لم يصرف البنك الشيك المدفوع بهذا السند بعد. استرد رصيده بعد أن يصرف البنك الشيك.",
    "QUOTATION_OUTDATED": "أحد بنود عرض السعر هذا لم يعد صالحًا كما سُعّر (أُرشف منتج أو وحدة أو نسبة ضريبة، أو تغيّر حجم عبوة). لا يمكن تعديل عرض سعر معتمد: سجّله كعرض خاسر ثم عدّله، أو أنشئ نسخة منه، ثم اعتمده مرة أخرى قبل تحويله.",
    "ORG_UNIT_REQUIRED": "تشمل صلاحيتك جزءًا من مستندات المبيعات، لذا يُسجَّل كل مستند تنشئه في وحدتك الأساسية، وليست لديك وحدة أساسية. اطلب من مدير النظام تحديد وحدتك الأساسية.",
    "ORG_UNIT_OUT_OF_SCOPE": "وحدتك الأساسية خارج الوحدات التي تشملها صلاحيتك في المبيعات، فلن ترى هذا المستند بعد حفظه. اطلب من مدير النظام تعديل وحدتك الأساسية أو صلاحيتك."
  },
  "lines": {
    "label": "البنود",
    "product": "المنتج",
    "productOf": "منتج البند {{n}}",
    "chooseProduct": "ابحث عن منتج…",
    "description": "الوصف",
    "descriptionOf": "وصف البند {{n}}",
    "descriptionPlaceholder": "أو اكتب وصف البند",
    "quantity": "الكمية",
    "quantityOf": "كمية البند {{n}}",
    "price": "سعر الوحدة",
    "priceInclusive": "السعر شامل الضريبة",
    "priceOf": "سعر وحدة البند {{n}}",
    "discount": "الخصم",
    "discountTypeOf": "نوع خصم البند {{n}}",
    "discountType": {
      "PERCENTAGE": "نسبة مئوية",
      "PER_UNIT": "مبلغ لكل وحدة",
      "LINE_AMOUNT": "مبلغ من إجمالي البند"
    },
    "perUnitValue": "{{amount}} للوحدة",
    "perLineValue": "{{amount}} للبند",
    "tax": "الضريبة",
    "taxOf": "نسبة ضريبة البند {{n}}",
    "noTax": "بدون ضريبة",
    "lineTotal": "إجمالي البند",
    "returned": "المرتجع",
    "add": "إضافة بند",
    "remove": "حذف البند {{n}}",
    "actions": "إجراءات البند",
    "totalsLabel": "الإجمالي",
    "enterHint": "Enter في البند الأخير يضيف بندًا جديدًا. امسح الباركود في حقل المنتج لإضافته.",
    "wholeUnits": "هذا المنتج يُعدّ بوحدات كاملة.",
    "productAndDescription": "المنتج / الوصف",
    "addDescription": "إضافة وصف",
    "lineN": "في البند {{n}}",
    "noTaxShort": "بلا ضريبة",
    "enterHintText": "Enter في البند الأخير يضيف بندًا جديدًا.",
    "taxable": "الخاضع للضريبة",
    "discountOfTyped": "خصم البند {{n}}، {{type}}",
    "discountShort": {
      "PERCENTAGE": "%",
      "PER_UNIT": "للوحدة",
      "LINE_AMOUNT": "للبند"
    },
    "discountAs": {
      "PERCENTAGE": "نسبة مئوية",
      "PER_UNIT": "مبلغ لكل وحدة",
      "LINE_AMOUNT": "مبلغ من إجمالي البند"
    },
    "sold": "المباع",
    "soldOf": "المباع {{quantity}}",
    "stillReturnable": "يمكن إرجاع {{quantity}} بعد",
    "serials": {
      "short": "اختر رقمًا تسلسليًا لكل وحدة: اختير {{picked}} من {{quantity}}.",
      "wholeUnits": "تُعدّ المنتجات ذات الأرقام التسلسلية بوحدات كاملة، لكل وحدة رقم تسلسلي.",
      "notSold": "لم يُبع في بند الفاتورة هذا، أو أُرجع بالفعل: {{serials}}",
      "codes": {
        "SERIAL_COUNT_MISMATCH": "الأرقام التسلسلية لا تطابق الكمية: {{serials}}",
        "SERIAL_NOT_AVAILABLE": "غير متوفر في مخزون هذا المستودع: {{serials}}",
        "SERIAL_DUPLICATE": "مكرر، أو موجود في المخزون بالفعل: {{serials}}",
        "SERIALS_NOT_TRACKED": "هذا المنتج لا يتتبع الأرقام التسلسلية: {{serials}}",
        "SERIAL_MOVED_ON": "تغيّر وضعه منذ ذلك الحين: {{serials}}"
      }
    }
  },
  "totals": {
    "gross": "المبلغ قبل الخصم",
    "discount": "الخصم",
    "subtotal": "المبلغ الخاضع للضريبة",
    "tax": "ضريبة القيمة المضافة",
    "taxAt": "ضريبة القيمة المضافة {{rate}}",
    "total": "الإجمالي",
    "paid": "المدفوع",
    "balance": "الرصيد المستحق",
    "inclusiveNote": "الأسعار شاملة الضريبة. يُعرض المبلغ قبل الخصم والخصومات دون الضريبة.",
    "exclusiveNote": "الأسعار غير شاملة الضريبة.",
    "inclusiveShort": "الأسعار شاملة الضريبة",
    "exclusiveShort": "الأسعار غير شاملة الضريبة",
    "credited": "المخصوم بإشعارات دائنة",
    "title": "الإجماليات"
  },
  "allocations": {
    "date": "تاريخ التطبيق",
    "amount": "المبلغ",
    "total": "إجمالي المطبّق",
    "source": "سُدّد بموجب",
    "number": "المستند",
    "receipt": "سند قبض",
    "creditNote": "إشعار دائن"
  },
  "void": {
    "reason": "السبب",
    "reasonWas": "السبب: {{reason}}"
  },
  "print": {
    "companySlot": "يظهر هنا عنوان الشركة ورقمها الضريبي بعد تعبئة ملف الشركة (الإدارة › الإعدادات).",
    "taxInvoice": "فاتورة ضريبية",
    "debitNote": "إشعار مدين",
    "creditNote": "إشعار دائن",
    "quotation": "عرض سعر",
    "back": "رجوع",
    "billTo": "الفاتورة إلى",
    "customerCode": "رمز العميل",
    "customerVat": "الرقم الضريبي",
    "phone": "الهاتف",
    "email": "البريد الإلكتروني",
    "footer": "المبالغ بالريال العُماني (<rial/>).",
    "vatNumber": "الرقم الضريبي",
    "crNumber": "السجل التجاري",
    "creditTo": "لصالح",
    "preparedFor": "مُعدّ لـ",
    "quotationFooter": "المبالغ بالريال العُماني (<rial/>). ساري حتى {{date}}.",
    "voidBanner": "ملغاة — غير مستحقة الدفع",
    "voidBody": "أُلغيت هذه الفاتورة، ولا يُستحق عليها أي مبلغ.",
    "owedSummary": "الرصيد المستحق {{amount}} · تستحق في {{date}}",
    "signature": "التوقيع المعتمد",
    "companyStamp": "ختم الشركة",
    "receivedByCustomer": "توقيع المستلم",
    "signatureBlock": "التوقيع وختم الشركة",
    "terms": "الشروط والأحكام",
    "paymentDetails": "بيانات الدفع",
    "accountNo": "رقم الحساب",
    "iban": "الآيبان"
  },
  "invoices": {
    "title": "الفواتير",
    "new": "فاتورة جديدة",
    "newDebitNote": "إشعار مدين جديد",
    "newTitle": "فاتورة جديدة",
    "newSubtitle": "تُحفظ مسودةً، ويُعيَّن الرقم عند الترحيل.",
    "newDebitNoteTitle": "إشعار مدين جديد",
    "newDebitNoteSubtitle": "مبلغ إضافي على العميل مقابل خدمات أو مبالغ. يُحفظ مسودةً.",
    "editTitle": "تعديل {{title}}",
    "editSubtitle": "تعديل المسودة",
    "draftInvoice": "مسودة فاتورة",
    "draftDebitNote": "مسودة إشعار مدين",
    "saveDraft": "حفظ المسودة",
    "notDraftTitle": "لم تعد هذه الفاتورة مسودة",
    "backToInvoice": "العودة إلى الفاتورة",
    "voidTitle": "هذه الفاتورة مُبطَلة",
    "mainWarehouse": "المستودع الرئيسي",
    "mainWarehouseNamed": "المستودع الرئيسي ({{code}})",
    "searchLabel": "البحث في الفواتير",
    "searchPlaceholder": "الرقم، العميل، المرجع…",
    "kindFilter": "التصفية حسب النوع",
    "allKinds": "كل الأنواع",
    "views": {
      "label": "طرق عرض الفواتير",
      "all": "الكل",
      "open": "المفتوحة",
      "void": "المُبطَلة",
      "drafts": "المسودات",
      "overdue": "المتأخرة",
      "paid": "المدفوعة",
      "owed": "مستحق"
    },
    "empty": {
      "all": "لا توجد فواتير بعد.",
      "body": "أنشئ فاتورة لعميل، أو حوّل عرض سعر معتمدًا.",
      "open": "لا شيء بانتظار السداد.",
      "void": "لا توجد فواتير مُبطَلة.",
      "drafts": "لا توجد مسودات فواتير.",
      "mine": "ليست لديك مسودات بانتظار الترحيل.",
      "overdue": "لا شيء متأخر.",
      "paid": "لا فواتير مدفوعة في طريقة العرض هذه."
    },
    "sections": {
      "invoice": "الفاتورة",
      "debitNote": "الإشعار المدين",
      "settlements": "التسويات",
      "creditNotes": "الإشعارات الدائنة الصادرة عليها",
      "document": "البنود والإجماليات",
      "details": "التفاصيل",
      "customerAndDates": "العميل والتواريخ"
    },
    "fields": {
      "invoiceDate": "تاريخ الفاتورة",
      "dueDate": "تاريخ الاستحقاق",
      "warehouse": "المستودع",
      "taxMode": "الضريبة",
      "createdBy": "أنشأها"
    },
    "hints": {
      "dueDate": "بعد {{days}} يومًا من تاريخ الفاتورة ما لم تختر تاريخًا آخر.",
      "warehouse": "تُصرف البضاعة منه عند ترحيل الفاتورة.",
      "reference": "رقم طلب العميل أو مرجعك الخاص.",
      "lines": "ابحث عن منتج بالاسم أو رمز الصنف أو الباركود، أو اكتب وصف البند بنفسك.",
      "debitNoteLines": "الإشعار المدين يحمّل خدمات أو مبالغ؛ أما البضائع فتُفوتر.",
      "notes": "تُطبع على الفاتورة.",
      "termDays_zero": "{{count}} يوم",
      "termDays_one": "يوم واحد",
      "termDays_two": "يومان",
      "termDays_few": "{{count}} أيام",
      "termDays_many": "{{count}} يومًا",
      "termDays_other": "{{count}} يوم",
      "linesText": "صِف كل بند: ما بيع وكميته وسعره."
    },
    "actions": {
      "post": "ترحيل",
      "void": "إبطال الفاتورة",
      "delete": "حذف المسودة",
      "open": "فتح",
      "edit": "تعديل",
      "duplicate": "إنشاء نسخة",
      "reissue": "إعادة الإصدار كمسودة جديدة",
      "recordReceipt": "تسجيل سند قبض",
      "print": "طباعة",
      "share": "مشاركة",
      "creditNote": "إشعار دائن",
      "applyCredit": "تطبيق رصيد",
      "viewSettlements": "عرض التسويات",
      "postMenu": "ترحيل…",
      "deleteMenu": "حذف المسودة…",
      "shareMenu": "مشاركة…",
      "voidMenu": "إبطال الفاتورة…"
    },
    "post": {
      "body": "الإجمالي {{total}}. يمنحها الترحيل رقمًا ويصرف البضاعة من المخزون ويسجّل البيع في الدفاتر. لا يمكن تعديلها بعد ذلك، بل إبطالها فقط.",
      "bodyDebitNote": "الإجمالي {{total}}. يمنحه الترحيل رقمًا ويسجّل المبلغ في الدفاتر. لا يمكن تعديله بعد ذلك، بل إبطاله فقط.",
      "confirmAnyway": "الترحيل رغم ذلك",
      "titleInvoice": "ترحيل فاتورة {{customer}}؟",
      "titleDebitNote": "ترحيل الإشعار المدين لـ{{customer}}؟",
      "dates": "بتاريخ {{date}} · تستحق في {{due}}",
      "stale_zero": "هذه الفاتورة مؤرخة اليوم.",
      "stale_one": "هذه الفاتورة مؤرخة قبل يوم واحد. يستخدم الترحيل هذا التاريخ.",
      "stale_two": "هذه الفاتورة مؤرخة قبل يومين. يستخدم الترحيل هذا التاريخ.",
      "stale_few": "هذه الفاتورة مؤرخة قبل {{count}} أيام. يستخدم الترحيل هذا التاريخ.",
      "stale_many": "هذه الفاتورة مؤرخة قبل {{count}} يومًا. يستخدم الترحيل هذا التاريخ.",
      "stale_other": "هذه الفاتورة مؤرخة قبل {{count}} يوم. يستخدم الترحيل هذا التاريخ.",
      "staleDebitNote_zero": "هذا الإشعار المدين مؤرخ اليوم.",
      "staleDebitNote_one": "هذا الإشعار المدين مؤرخ قبل يوم واحد. يستخدم الترحيل هذا التاريخ.",
      "staleDebitNote_two": "هذا الإشعار المدين مؤرخ قبل يومين. يستخدم الترحيل هذا التاريخ.",
      "staleDebitNote_few": "هذا الإشعار المدين مؤرخ قبل {{count}} أيام. يستخدم الترحيل هذا التاريخ.",
      "staleDebitNote_many": "هذا الإشعار المدين مؤرخ قبل {{count}} يومًا. يستخدم الترحيل هذا التاريخ.",
      "staleDebitNote_other": "هذا الإشعار المدين مؤرخ قبل {{count}} يوم. يستخدم الترحيل هذا التاريخ.",
      "changeDate": "تغيير التاريخ"
    },
    "delete": {
      "title": "حذف هذه المسودة؟",
      "body": "تُحذف المسودة. وإن كانت محوّلة من عرض سعر يعود عرض السعر ليُحوَّل من جديد."
    },
    "void": {
      "title": "إبطال {{number}}؟",
      "body": "يُعكس قيدها اليومي وتعود البضاعة إلى المخزون. تبقى الفاتورة في السجلات بحالة مُبطَلة.",
      "removeFirst_zero": "أزل التسويات أولًا.",
      "removeFirst_one": "أزل التسوية أولًا.",
      "removeFirst_two": "أزل التسويتين أولًا.",
      "removeFirst_few": "أزل التسويات الـ{{count}} أولًا.",
      "removeFirst_many": "أزل التسويات الـ{{count}} أولًا.",
      "removeFirst_other": "أزل التسويات الـ{{count}} أولًا.",
      "creditFirst_zero": "أبطِل الإشعارات الدائنة الصادرة عليها أولًا.",
      "creditFirst_one": "أبطِل الإشعار الدائن {{number}} أولًا.",
      "creditFirst_two": "أبطِل الإشعارين الدائنين الصادرين عليها أولًا.",
      "creditFirst_few": "أبطِل الإشعارات الدائنة الـ{{count}} الصادرة عليها أولًا.",
      "creditFirst_many": "أبطِل الإشعارات الدائنة الـ{{count}} الصادرة عليها أولًا.",
      "creditFirst_other": "أبطِل الإشعارات الدائنة الـ{{count}} الصادرة عليها أولًا.",
      "removeOne": "أزِل {{number}} من هذه الفاتورة أولًا.",
      "checkingCredits": "جارٍ التحقق من الإشعارات الدائنة…",
      "creditsFailed": "تعذّر تحميل الإشعارات الدائنة. أعد تحميل الصفحة للإبطال."
    },
    "toast": {
      "saved": "حُفظت المسودة",
      "posted": "رُحّلت الفاتورة {{number}}",
      "deleted": "حُذفت المسودة",
      "voided": "أُبطِل {{number}}",
      "postedDebitNote": "رُحّل الإشعار المدين {{number}}",
      "exported_zero": "لم تُصدَّر أي فاتورة",
      "exported_one": "صُدّرت فاتورة واحدة",
      "exported_two": "صُدّرت فاتورتان",
      "exported_few": "صُدّرت {{n}} فواتير",
      "exported_many": "صُدّرت {{n}} فاتورة",
      "exported_other": "صُدّرت {{n}} فاتورة",
      "exportedView": "صُدّرت فواتير طريقة العرض هذه",
      "savedDraft": "حُفظت كمسودة"
    },
    "export": "تصدير العرض",
    "exportHint_zero": "ملف CSV فارغ: لا فواتير في طريقة العرض هذه",
    "exportHint_one": "ملف CSV بفاتورة واحدة في طريقة العرض هذه",
    "exportHint_two": "ملف CSV بفاتورتين في طريقة العرض هذه",
    "exportHint_few": "ملف CSV بـ{{n}} فواتير في طريقة العرض هذه",
    "exportHint_many": "ملف CSV بـ{{n}} فاتورة في طريقة العرض هذه",
    "exportHint_other": "ملف CSV بـ{{n}} فاتورة في طريقة العرض هذه",
    "rowActions": "إجراءات {{number}}",
    "mine": "مسوداتي",
    "refShort": "المرجع",
    "voidedOn": "أُبطلت في {{date}}",
    "printedNotes": "ملاحظات (تُطبع)",
    "createdBySystem": "مستوردة أو من النظام",
    "moreDetails": "تفاصيل إضافية",
    "hasNotes": "ملاحظات",
    "saveAndPost": "حفظ وترحيل",
    "copyTitle": "فاتورة جديدة (نسخة من {{number}})",
    "copyDebitNoteTitle": "إشعار مدين جديد (نسخة من {{number}})",
    "copyFailed": "تعذّر تحميل الفاتورة المراد نسخها. ابدأ من هذه المسودة الفارغة، أو ارجع وأعد المحاولة.",
    "form": {
      "shortcuts": "{{save}} يحفظ المسودة · {{post}} يحفظ ويرحّل",
      "footerTotal_zero": "لا بنود · الإجمالي {{total}}",
      "footerTotal_one": "بند واحد · الإجمالي {{total}}",
      "footerTotal_two": "بندان · الإجمالي {{total}}",
      "footerTotal_few": "{{count}} بنود · الإجمالي {{total}}",
      "footerTotal_many": "{{count}} بندًا · الإجمالي {{total}}",
      "footerTotal_other": "{{count}} بند · الإجمالي {{total}}"
    },
    "list": {
      "daysOverdue_zero": "متأخرة {{count}} يوم",
      "daysOverdue_one": "متأخرة يومًا واحدًا",
      "daysOverdue_two": "متأخرة يومين",
      "daysOverdue_few": "متأخرة {{count}} أيام",
      "daysOverdue_many": "متأخرة {{count}} يومًا",
      "daysOverdue_other": "متأخرة {{count}} يوم",
      "daysLate_zero": "{{count}} يوم",
      "daysLate_one": "يوم واحد",
      "daysLate_two": "يومان",
      "daysLate_few": "{{count}} أيام",
      "daysLate_many": "{{count}} يومًا",
      "daysLate_other": "{{count}} يوم",
      "daysOverdueSpoken_zero": "متأخرة {{count}} يوم",
      "daysOverdueSpoken_one": "متأخرة يومًا واحدًا",
      "daysOverdueSpoken_two": "متأخرة يومين",
      "daysOverdueSpoken_few": "متأخرة {{count}} أيام",
      "daysOverdueSpoken_many": "متأخرة {{count}} يومًا",
      "daysOverdueSpoken_other": "متأخرة {{count}} يوم"
    },
    "figures": {
      "label": "أرقام الفاتورة",
      "vat": "الضريبة {{amount}}",
      "overdue_zero": "متأخرة {{count}} يوم",
      "overdue_one": "متأخرة يومًا واحدًا",
      "overdue_two": "متأخرة يومين",
      "overdue_few": "متأخرة {{count}} أيام",
      "overdue_many": "متأخرة {{count}} يومًا",
      "overdue_other": "متأخرة {{count}} يوم",
      "dueToday": "تستحق اليوم",
      "dueIn_zero": "تستحق اليوم",
      "dueIn_one": "تستحق بعد يوم واحد",
      "dueIn_two": "تستحق بعد يومين",
      "dueIn_few": "تستحق بعد {{count}} أيام",
      "dueIn_many": "تستحق بعد {{count}} يومًا",
      "dueIn_other": "تستحق بعد {{count}} يوم",
      "nothingPaid": "لم يُدفع شيء بعد",
      "nothingOwed": "لا شيء مستحق",
      "settled": "المسدَّد",
      "received": "{{amount}} مقبوض",
      "credited": "{{amount}} بإشعار دائن",
      "datedAgo_zero": "اليوم",
      "datedAgo_one": "قبل يوم واحد",
      "datedAgo_two": "قبل يومين",
      "datedAgo_few": "قبل {{count}} أيام",
      "datedAgo_many": "قبل {{count}} يومًا",
      "datedAgo_other": "قبل {{count}} يوم",
      "datedToday": "اليوم",
      "paidInFull": "سُدّدت بالكامل · {{date}}"
    },
    "settlements": {
      "none": "لا سندات قبض بعد.",
      "recordOne": "سجّل سند قبض.",
      "void": "مُبطَلة: لا شيء مستحق.",
      "removed": "أُزيل {{number}} من {{invoice}}",
      "removeTitle": "إزالة {{number}} من هذه الفاتورة؟",
      "removeBody": "يعود {{amount}} إلى الرصيد الدائن غير المستخدم للعميل، وتصبح الفاتورة مفتوحة بهذا المبلغ من جديد.",
      "remove": "إزالة",
      "removeNamed": "إزالة {{number}} من هذه الفاتورة",
      "creditNotice": "لدى {{customer}} رصيد دائن غير مستخدم بقيمة {{amount}}.",
      "applyIt": "طبّقه",
      "creditsFailed": "تعذّر تحميل الإشعارات الدائنة."
    },
    "stock": {
      "checking": "جارٍ التحقق من المخزون…",
      "failed": "تعذّر التحقق من المخزون. يمكنك الترحيل رغم ذلك.",
      "title_zero": "لا بنود ينقصها مخزون في {{warehouse}}",
      "title_one": "بند واحد ينقصه مخزون في {{warehouse}}",
      "title_two": "بندان ينقصهما مخزون في {{warehouse}}",
      "title_few": "{{count}} بنود ينقصها مخزون في {{warehouse}}",
      "title_many": "{{count}} بندًا ينقصها مخزون في {{warehouse}}",
      "title_other": "{{count}} بند ينقصها مخزون في {{warehouse}}",
      "line": "المطلوب {{required}}، المتوفر {{onHand}}",
      "hint": "يمكنك الترحيل رغم ذلك: يصبح المخزون بالسالب حتى تُستلم البضاعة.",
      "blockedTitle_zero": "المخزون لا يكفي للترحيل في {{warehouse}}",
      "blockedTitle_one": "المخزون لا يكفي للترحيل: بند واحد ينقصه مخزون في {{warehouse}}",
      "blockedTitle_two": "المخزون لا يكفي للترحيل: بندان ينقصهما مخزون في {{warehouse}}",
      "blockedTitle_few": "المخزون لا يكفي للترحيل: {{count}} بنود ينقصها مخزون في {{warehouse}}",
      "blockedTitle_many": "المخزون لا يكفي للترحيل: {{count}} بندًا ينقصها مخزون في {{warehouse}}",
      "blockedTitle_other": "المخزون لا يكفي للترحيل: {{count}} بند ينقصها مخزون في {{warehouse}}",
      "blockedHint": "تمنع سياسة المخزون المبيعات التي تُنزل المخزون إلى ما دون الصفر. استلم البضاعة أو حوّلها، أو خفّض الكميات، ثم رحّل من جديد.",
      "blockedHintInventoryOff": "تمنع سياسة المخزون المبيعات التي تُنزل المخزون إلى ما دون الصفر. وحدة المخزون متوقفة لشركتك، فلا يمكن تحويل المخزون أو جرده: خفّض الكميات، أو اطلب من المسؤول تغيير سياسة المخزون في الإعدادات › المخزون."
    },
    "errors": {
      "chooseCustomer": "اختر العميل"
    },
    "editDraftTitle": "تعديل مسودة الفاتورة",
    "editDraftDebitNoteTitle": "تعديل مسودة الإشعار المدين",
    "stampStatus": "الحالة:",
    "stampPayment": "الدفع:",
    "stats": {
      "label": "أرقام الفواتير",
      "open": "المفتوحة",
      "overdue": "المتأخرة",
      "netSales": "صافي المبيعات",
      "netSalesDetail": "{{month}} · {{invoices}}",
      "drafts": "المسودات",
      "draftsDetail": "بانتظار الترحيل",
      "overdueShare": "{{percent}}٪ من الرصيد المفتوح متأخر",
      "trend": "صافي المبيعات حسب الشهر، من {{from}} إلى {{to}}",
      "unavailable": "الأرقام غير متاحة",
      "invoices_zero": "لا فواتير",
      "invoices_one": "فاتورة واحدة",
      "invoices_two": "فاتورتان",
      "invoices_few": "{{n}} فواتير",
      "invoices_many": "{{n}} فاتورة",
      "invoices_other": "{{n}} فاتورة"
    }
  },
  "quotations": {
    "status": {
      "PENDING": "قيد الانتظار",
      "APPROVED": "معتمد",
      "REJECTED": "مرفوض",
      "CONVERTED": "محوّل",
      "EXPIRED": "منتهي الصلاحية",
      "EXPIRES_SOON": "ينتهي قريبًا"
    },
    "title": "عروض الأسعار",
    "subtitle": "عروض الأسعار للعملاء. يتحول العرض المعتمد إلى مسودة فاتورة.",
    "new": "عرض سعر جديد",
    "newTitle": "عرض سعر جديد",
    "newSubtitle": "يُعيَّن الرقم عند الحفظ. لا يُرحَّل شيء ولا يُصرف من المخزون.",
    "editTitle": "تعديل {{number}}",
    "editSubtitle": "تعديل عرض السعر",
    "save": "حفظ عرض السعر",
    "kind": "عرض سعر",
    "notEditableTitle": "لم يعد تعديل عرض السعر هذا ممكنًا",
    "backToQuotation": "العودة إلى عرض السعر",
    "editRejected": "رُفض عرض السعر هذا. حفظ تعديلاتك يعيده قيد الانتظار.",
    "expiredTitle": "انتهت صلاحية عرض السعر هذا",
    "expiredBody": "كان ساريًا حتى {{date}}. لا يزال تحويله ممكنًا بعد التأكيد.",
    "rejectedTitle": "رُفض عرض السعر هذا",
    "approvedOn": "اعتُمد {{at}}",
    "rejectedOn": "رُفض {{at}}",
    "searchLabel": "البحث في عروض الأسعار",
    "searchPlaceholder": "ابحث بالرقم أو العميل…",
    "sections": {
      "quotation": "عرض السعر",
      "summary": "ملخص"
    },
    "fields": {
      "quotationDate": "تاريخ العرض",
      "validUntil": "ساري حتى",
      "decided": "القرار",
      "converted": "حُوّل",
      "approved": "الاعتماد",
      "rejected": "الرفض",
      "lost": "سُجّل خاسرًا",
      "invoice": "الفاتورة"
    },
    "hints": {
      "validUntil": "بعد {{days}} يومًا من تاريخ العرض ما لم تختر تاريخًا آخر.",
      "notes": "تُطبع على عرض السعر."
    },
    "views": {
      "label": "عروض عروض الأسعار",
      "all": "الكل",
      "pending": "قيد الانتظار",
      "approved": "المعتمدة",
      "expired": "المنتهية",
      "converted": "المحوّلة",
      "rejected": "المرفوضة أو الخاسرة",
      "value": "القيمة المفتوحة"
    },
    "stats": {
      "label": "أرقام عروض الأسعار",
      "pending": "قيد الانتظار",
      "pendingDetail": "{{quotations}} بانتظار القرار",
      "approved": "المعتمدة",
      "approvedDetail": "{{quotations}} للتحويل إلى فواتير",
      "conversion": "المحوّلة",
      "percent": "{{percent}}٪",
      "none": "—",
      "conversionDetail": "{{converted}} من {{decided}} حُسم أمرها",
      "conversionEmpty": "لم يُحسم أي عرض بعد",
      "conversionShare": "{{percent}}٪ من العروض المحسومة حُوّلت إلى فواتير",
      "expired": "المنتهية",
      "expiredDetail": "تجاوزت تاريخ الصلاحية وما زالت مفتوحة",
      "quotations_zero": "لا عروض",
      "quotations_one": "عرض واحد",
      "quotations_two": "عرضان",
      "quotations_few": "{{n}} عروض",
      "quotations_many": "{{n}} عرضًا",
      "quotations_other": "{{n}} عرض"
    },
    "empty": {
      "all": "لا توجد عروض أسعار بعد.",
      "body": "أرسل لعميل عرض سعر؛ وبعد اعتماده يصبح مسودة فاتورة بخطوة واحدة.",
      "pending": "لا توجد عروض بانتظار قرار.",
      "approved": "لا توجد عروض معتمدة للتحويل.",
      "expired": "لا توجد عروض مفتوحة منتهية.",
      "converted": "لم يُحوَّل أي عرض بعد.",
      "rejected": "لا توجد عروض مرفوضة أو خاسرة."
    },
    "actions": {
      "approve": "اعتماد",
      "reject": "رفض",
      "convert": "تحويل إلى فاتورة",
      "viewInvoice": "عرض الفاتورة",
      "delete": "حذف عرض السعر",
      "approveConvert": "اعتماد وتحويل",
      "edit": "تعديل",
      "rejectMenu": "رفض…",
      "markLost": "تسجيل كعرض خاسر",
      "markLostMenu": "تسجيل كعرض خاسر…",
      "shareMenu": "مشاركة…"
    },
    "approve": {
      "title": "اعتماد {{number}}؟",
      "body": "يمكن تحويل العرض المعتمد إلى فاتورة، ولا يمكن تعديله بعد ذلك."
    },
    "delete": {
      "title": "حذف {{number}}؟",
      "body": "يُحذف عرض السعر، ولا يُعاد استخدام رقمه."
    },
    "reject": {
      "title": "رفض {{number}}؟",
      "body": "يمكن تعديل العرض المرفوض، فيعود قيد الانتظار.",
      "reason": "السبب",
      "reasonHint": "اختياري. يظهر على عرض السعر."
    },
    "convert": {
      "title": "تحويل {{number}} إلى فاتورة",
      "body": "تُنشأ مسودة فاتورة من بنود العرض بالتسعير نفسه. راجعها ثم رحّلها.",
      "confirm": "إنشاء مسودة الفاتورة",
      "expiredTitle": "انتهت صلاحية عرض السعر هذا",
      "expiredBody": "كان ساريًا حتى {{date}}. ربما تغيّرت الأسعار منذ ذلك الحين.",
      "confirmExpired": "تحويله رغم ذلك",
      "approveTitle": "اعتماد {{number}} وتحويله",
      "approveBody": "يُعتمد عرض السعر، ثم تُنشأ مسودة فاتورة من بنوده بالتسعير نفسه. راجعها ثم رحّلها.",
      "approveConfirm": "اعتماد وإنشاء مسودة فاتورة",
      "approvedOnly": "اعتُمد ولم يُحوَّل"
    },
    "toast": {
      "created": "أُنشئ عرض السعر {{number}}",
      "saved": "حُفظ عرض السعر",
      "approved": "اعتُمد {{number}}",
      "rejected": "رُفض {{number}}",
      "deleted": "حُذف {{number}}",
      "converted": "حُوّل {{number}} إلى مسودة فاتورة",
      "savedApproved": "حُفظ {{number}} واعتُمد",
      "savedNotApproved": "حُفظ {{number}} ولم يُعتمد: {{reason}}",
      "lost": "سُجّل {{number}} كعرض خاسر"
    },
    "copyTitle": "نسخة من {{number}}",
    "copyFailed": "تعذّر تحميل عرض السعر المراد نسخه. هذا عرض سعر فارغ.",
    "copyTaxMode": {
      "title": "راجع الأسعار المنسوخة",
      "nowExclusive": "سُعّر {{number}} بأسعار شاملة الضريبة. تُسعَّر عروض الأسعار الجديدة قبل الضريبة، لذا تُقرأ الأسعار المنسوخة الآن قبل الضريبة ويزيد الإجمالي بمقدارها.",
      "nowInclusive": "سُعّر {{number}} بأسعار قبل الضريبة. تُسعَّر عروض الأسعار الجديدة شاملة الضريبة، لذا تشمل الأسعار المنسوخة الضريبة الآن وينقص الإجمالي بمقدارها."
    },
    "changedMeanwhile": "عُدّل {{number}} منذ أن فتحته. تُعرض الآن أحدث نسخة منه: راجعها، ثم أعد المحاولة.",
    "lost": {
      "title": "تسجيل {{number}} كعرض خاسر؟",
      "body": "رفض العميل العرض أو حلّ محله عرض آخر. يُغلق كمرفوض مع ذكر السبب. لتقديم عرض جديد، انسخه.",
      "reasonHint": "سبب خسارة العرض. يُحفظ مع عرض السعر.",
      "reasonRequired": "اذكر سبب خسارة العرض"
    },
    "lostTitle": "خُسر هذا العرض",
    "saveAndApprove": "حفظ واعتماد",
    "validity": {
      "validFor_zero": "اليوم آخر يوم",
      "validFor_one": "صالح ليوم آخر",
      "validFor_two": "صالح ليومين آخرين",
      "validFor_few": "صالح لـ{{count}} أيام أخرى",
      "validFor_many": "صالح لـ{{count}} يومًا آخر",
      "validFor_other": "صالح لـ{{count}} يوم آخر",
      "left_zero": "آخر يوم",
      "left_one": "يوم واحد متبقٍ",
      "left_two": "يومان متبقيان",
      "left_few": "{{count}} أيام متبقية",
      "left_many": "{{count}} يومًا متبقيًا",
      "left_other": "{{count}} يوم متبقٍ",
      "expiredAgo_zero": "انتهى اليوم",
      "expiredAgo_one": "انتهى أمس",
      "expiredAgo_two": "انتهى قبل يومين",
      "expiredAgo_few": "انتهى قبل {{count}} أيام",
      "expiredAgo_many": "انتهى قبل {{count}} يومًا",
      "expiredAgo_other": "انتهى قبل {{count}} يوم"
    }
  },
  "creditNotes": {
    "draftTitle": "مسودة إشعار دائن",
    "kind": {
      "RETURN": "مرتجع",
      "ALLOWANCE": "مسموح به"
    },
    "title": "الإشعارات الدائنة",
    "subtitle": "المرتجعات والمسموحات التي تخفّض مستحقات العملاء.",
    "new": "إشعار دائن جديد",
    "newTitle": "إشعار دائن جديد",
    "newSubtitle": "يُحفظ مسودةً، ويُعيَّن الرقم عند الترحيل.",
    "editTitle": "تعديل {{title}}",
    "editSubtitle": "تعديل المسودة",
    "saveDraft": "حفظ المسودة",
    "notDraftTitle": "لم يعد هذا الإشعار الدائن مسودة",
    "backToNote": "العودة إلى الإشعار الدائن",
    "voidTitle": "هذا الإشعار الدائن مُبطَل",
    "draftNote": "هذه مسودة: لم تُسجَّل في الدفاتر بعد. رحّلها لإضافة المبلغ لصالح العميل.",
    "creditTitle": "رصيد غير مستخدم: {{amount}}",
    "creditBody": "المبلغ رصيد غير مستخدم في حساب العميل. طبّقه على فواتيره المفتوحة.",
    "applied": "المطبّق",
    "noAllocations": "لم يُطبّق هذا الإشعار الدائن على أي فاتورة.",
    "unallocateBody": "تعود الفاتورة مفتوحة بهذا المبلغ، ويعود المبلغ رصيدًا غير مستخدم للعميل.",
    "remainder": "يبقى {{amount}} رصيدًا غير مستخدم في حساب العميل.",
    "searchLabel": "البحث في الإشعارات الدائنة",
    "searchPlaceholder": "ابحث بالرقم أو السبب أو العميل…",
    "kindFilter": "التصفية حسب النوع",
    "allKinds": "المرتجعات والمسموحات",
    "invoiceWarehouse": "مستودع الفاتورة",
    "invoiceWarehouseNamed": "مستودع الفاتورة ({{code}})",
    "chooseInvoice": "اختر فاتورة",
    "chooseCustomerFirst": "اختر العميل أولًا",
    "searchInvoices": "ابحث برقم الفاتورة…",
    "noInvoices": "لا توجد فواتير مرحّلة لهذا العميل.",
    "noInvoice": "ليس على فاتورة",
    "pickInvoice": "اختر الفاتورة التي صُرفت منها البضاعة.",
    "pickInvoiceBody": "تظهر بنودها هنا مع ما يمكن إرجاعه من كل بند.",
    "returnAll": "إرجاع كل المتبقي",
    "sold": "المباع",
    "returnable": "يمكن إرجاعه",
    "returnQuantity": "المرتجع",
    "returnQuantityOf": "الكمية المرتجعة من {{description}}",
    "credited": "المبلغ الدائن",
    "totalCredit": "إجمالي المبلغ الدائن",
    "kindHint": {
      "RETURN": "بضاعة أو خدمات عائدة من فاتورة. الأسعار والخصومات والضريبة تؤخذ من الفاتورة.",
      "ALLOWANCE": "تخفيض سعر أو مبلغ ترضية، مع فاتورة أو بدونها. لا يتحرك المخزون."
    },
    "sections": {
      "note": "الإشعار الدائن",
      "returnLines": "البنود المرتجعة",
      "allocations": "الفواتير المسددة"
    },
    "fields": {
      "kind": "النوع",
      "invoice": "الفاتورة",
      "date": "التاريخ",
      "warehouse": "المستودع المُرجع إليه",
      "reason": "السبب"
    },
    "hints": {
      "returnInvoice": "لا يُصدر إشعار دائن إلا على فاتورة مرحّلة.",
      "allowanceInvoice": "اختياري. عند اختيارها يتبع الإشعار طريقة ضريبتها ويُطبّق عليها عند الترحيل.",
      "warehouse": "حيث تعود البضاعة المرتجعة إلى المخزون.",
      "reason": "يُطبع على الإشعار الدائن.",
      "returnLines": "أدخل الكمية العائدة لكل بند، بحد أقصى ما يمكن إرجاعه.",
      "allowanceLines": "صف ما يُضاف لصالح العميل مع ضريبته."
    },
    "errors": {
      "returnLimit": "إحدى الكميات أكبر مما يمكن إرجاعه. صحّح البنود المظلّلة.",
      "noReturnLines": "أدخل كمية مرتجعة في بند واحد على الأقل.",
      "lineLimit": "يمكن إرجاع {{quantity}} فقط."
    },
    "actions": {
      "post": "ترحيل",
      "apply": "التطبيق على الفواتير",
      "delete": "حذف المسودة",
      "void": "إبطال الإشعار الدائن",
      "edit": "تعديل",
      "postMenu": "ترحيل…"
    },
    "post": {
      "title": "ترحيل هذا الإشعار الدائن إلى {{customer}}؟",
      "body": "الإجمالي {{total}}. يمنحه الترحيل رقمًا ويسجّله في الدفاتر، وتعود البضاعة المرتجعة إلى المخزون.",
      "unapplied": "يبقى المبلغ رصيدًا غير مستخدم في حساب العميل حتى تطبّقه أو تستردّه.",
      "appliesAll": "يُطبّق {{total}} على {{invoice}}.",
      "appliesPart": "يُطبّق {{applied}} على {{invoice}}، ويبقى {{rest}} رصيدًا غير مستخدم لـ{{customer}}.",
      "appliesNone": "{{invoice}} مسددة بالكامل، لذا يبقى {{total}} رصيدًا غير مستخدم لـ{{customer}}. استردّه أو طبّقه لاحقًا.",
      "appliesUnknown": "يُطبّق على ما تبقّى مستحقًا على {{invoice}}، ويبقى ما يزيد رصيدًا غير مستخدم لـ{{customer}}.",
      "date": "{{kind}} بتاريخ {{date}}، بالريال العُماني.",
      "stale_zero": "مؤرخ اليوم.",
      "stale_one": "مؤرخ قبل يوم. تحقّق من التاريخ قبل الترحيل.",
      "stale_two": "مؤرخ قبل يومين. تحقّق من التاريخ قبل الترحيل.",
      "stale_few": "مؤرخ قبل {{count}} أيام. تحقّق من التاريخ قبل الترحيل.",
      "stale_many": "مؤرخ قبل {{count}} يومًا. تحقّق من التاريخ قبل الترحيل.",
      "stale_other": "مؤرخ قبل {{count}} يوم. تحقّق من التاريخ قبل الترحيل."
    },
    "delete": {
      "title": "حذف هذه المسودة؟",
      "body": "تُحذف مسودة الإشعار الدائن."
    },
    "apply": {
      "title": "تطبيق {{number}}",
      "body": "الرصيد غير المستخدم في هذا الإشعار الدائن: {{amount}}."
    },
    "void": {
      "title": "إبطال {{number}}؟",
      "body": "تُحرَّر المبالغ المطبّقة على الفواتير ويُعكس قيده اليومي. يبقى الإشعار في السجلات بحالة مُبطَل.",
      "bodyReturn": "تُحرَّر المبالغ المطبّقة على الفواتير ويُعكس قيده اليومي وتخرج البضاعة المرتجعة من المخزون مجددًا. يبقى الإشعار في السجلات بحالة مُبطَل."
    },
    "toast": {
      "saved": "حُفظت المسودة",
      "posted": "رُحّل الإشعار الدائن",
      "deleted": "حُذفت المسودة",
      "applied": "طُبّق على الفواتير",
      "voided": "أُبطِل {{number}}",
      "savedDraft": "حُفظ الإشعار الدائن كمسودة",
      "view": "عرض الإشعار الدائن",
      "postedNumber": "رُحّل الإشعار الدائن {{number}}"
    },
    "empty": {
      "title": "لا توجد إشعارات دائنة بعد.",
      "body": "سجّل مرتجعًا أو تخفيض سعر من الفاتورة أو من هنا.",
      "drafts": "لا توجد مسودات إشعارات دائنة.",
      "withCredit": "لا توجد إشعارات دائنة برصيد غير مستخدم.",
      "void": "لا توجد إشعارات دائنة ملغاة."
    },
    "choice": {
      "RETURN": "إرجاع بضاعة",
      "ALLOWANCE": "خصم مسموح به"
    },
    "saveAndPost": "حفظ وترحيل",
    "views": {
      "label": "عروض الإشعارات الدائنة",
      "all": "الكل",
      "drafts": "المسودات",
      "withCredit": "برصيد غير مستخدم",
      "void": "الملغاة"
    },
    "stats": {
      "label": "أرقام الإشعارات الدائنة",
      "unapplied": "رصيد غير مخصص",
      "unappliedDetail": "{{notes}} للتخصيص أو الاسترداد",
      "drafts": "المسودات",
      "draftsDetail": "بانتظار الترحيل",
      "credited": "المُعاد قبل الضريبة",
      "creditedDetail": "{{month}} · {{notes}}",
      "creditedAll": "{{month}} · كل العملاء",
      "trend": "المُعاد قبل الضريبة حسب الشهر، من {{from}} إلى {{to}}",
      "unavailable": "الأرقام غير متاحة",
      "void": "الملغاة",
      "voidDetail": "ملغاة، بلا أثر على الأرصدة",
      "notes_zero": "لا إشعارات دائنة",
      "notes_one": "إشعار دائن واحد",
      "notes_two": "إشعاران دائنان",
      "notes_few": "{{n}} إشعارات دائنة",
      "notes_many": "{{n}} إشعارًا دائنًا",
      "notes_other": "{{n}} إشعار دائن"
    }
  },
  "method": {
    "CASH": "نقدًا",
    "CARD": "بطاقة",
    "BANK_TRANSFER": "تحويل بنكي",
    "CHEQUE": "شيك",
    "OTHER": "أخرى"
  },
  "allocate": {
    "fillOldest": "التوزيع على الأقدم أولًا",
    "clear": "مسح المبالغ",
    "limited": "تُعرض أقدم {{n}} فاتورة مفتوحة.",
    "noOpen": "لا توجد فواتير مفتوحة لهذا العميل.",
    "noOpenBody": "يبقى المبلغ كاملًا رصيدًا غير مستخدم في حساب العميل ليُطبّق لاحقًا.",
    "tableLabel": "الفواتير المفتوحة",
    "apply": "تطبيق",
    "applyTo": "المبلغ المطبّق على {{number}}",
    "overBalance": "أكبر من المتبقي على هذه الفاتورة.",
    "available": "المبلغ المراد تطبيقه",
    "allocated": "المطبّق",
    "unallocated": "غير مستخدم",
    "exceeds": "المبالغ تزيد بمقدار {{amount}} على المبلغ المراد تطبيقه. خفّضها.",
    "exceedsReceipt": "مجموع المبالغ المطبّقة أكبر من مبلغ السند. خفّضها أو ارفع المبلغ.",
    "confirm": "تطبيق",
    "refunded": "المسترد"
  },
  "receipts": {
    "title": "سندات القبض",
    "subtitle": "المبالغ المقبوضة من العملاء والفواتير التي تسددها.",
    "new": "تسجيل سند قبض",
    "newTitle": "تسجيل سند قبض",
    "newSubtitle": "يُرحّل إلى الدفاتر فورًا، ويُعيَّن الرقم عند الحفظ.",
    "kind": "سند قبض",
    "save": "تسجيل السند",
    "searchLabel": "البحث في سندات القبض",
    "searchPlaceholder": "ابحث بالرقم أو المرجع أو العميل…",
    "chooseAccount": "اختر الحساب النقدي أو البنكي",
    "chooseCustomerFirst": "اختر العميل لعرض فواتيره المفتوحة.",
    "remainder": "يبقى {{amount}} رصيدًا غير مستخدم في حساب العميل ليُطبّق على فواتير لاحقة.",
    "creditTitle": "رصيد غير مستخدم: {{amount}}",
    "creditBody": "المبلغ رصيد غير مستخدم في حساب العميل. طبّقه على الفواتير عند إصدارها.",
    "voidTitle": "هذا السند مُبطَل",
    "noAllocations": "لم يُطبّق هذا السند على أي فاتورة.",
    "noAllocationsHint": "طبّقه على فواتير العميل المفتوحة.",
    "sections": {
      "receipt": "سند القبض",
      "allocation": "التطبيق على الفواتير",
      "allocations": "الفواتير المسددة",
      "payment": "الدفع"
    },
    "fields": {
      "date": "تاريخ السند",
      "amount": "المبلغ المقبوض",
      "account": "أُودع في",
      "method": "طريقة الدفع",
      "invoice": "الفاتورة",
      "recordedAt": "تاريخ التسجيل"
    },
    "hints": {
      "noAccounts": "لا يوجد حساب نقدي أو بنكي نشط. اطلب من المسؤول إضافته من المحاسبة › النقدية والبنوك.",
      "reference": "رقم الشيك أو التحويل.",
      "allocation": "طبّق المبلغ على فواتير العميل المفتوحة، الأقدم أولًا أو مبلغًا مبلغًا."
    },
    "actions": {
      "allocate": "التطبيق على الفواتير",
      "void": "إبطال سند القبض",
      "unallocate": "إزالة",
      "unallocateNamed": "إزالة المبلغ المطبّق على {{number}}",
      "label": "إجراءات"
    },
    "allocate": {
      "title": "تطبيق {{number}}",
      "body": "الرصيد غير المستخدم في سند القبض هذا: {{amount}}."
    },
    "unallocate": {
      "title": "إزالة المبلغ المطبّق على {{number}}؟",
      "body": "تعود {{invoice}} مفتوحة بمبلغ {{amount}}، ويصبح {{amount}} رصيدًا غير مستخدم لـ{{customer}}."
    },
    "void": {
      "title": "إبطال {{number}}؟",
      "body": "يُخصم {{amount}} من الرصيد غير المستخدم لـ{{customer}} ومن {{account}}، ويُعكس قيده اليومي. يبقى السند في السجلات بحالة مُبطَل.",
      "bodyApplied": "يُخصم {{amount}} من {{account}}، ويُعكس قيده اليومي. يبقى السند في السجلات بحالة مُبطَل.",
      "reopens_zero": "تعود الفواتير {{invoices}} مستحقة بقدر ما سدّده هذا السند.",
      "reopens_one": "تعود الفاتورة {{invoices}} مستحقة بقدر ما سدّده هذا السند.",
      "reopens_two": "تعود الفاتورتان {{invoices}} مستحقتين بقدر ما سدّده هذا السند.",
      "reopens_few": "تعود {{count}} فواتير مستحقة بقدر ما سدّده هذا السند: {{invoices}}.",
      "reopens_many": "تعود {{count}} فاتورة مستحقة بقدر ما سدّده هذا السند: {{invoices}}.",
      "reopens_other": "تعود {{count}} فاتورة مستحقة بقدر ما سدّده هذا السند: {{invoices}}."
    },
    "toast": {
      "created": "سُجّل سند القبض {{number}}",
      "allocated": "طُبّق على الفواتير",
      "unallocated": "أُزيل من {{number}}",
      "voided": "أُبطِل {{number}}",
      "view": "عرض سند القبض"
    },
    "empty": {
      "title": "لا توجد سندات قبض بعد.",
      "body": "سجّل مبلغًا مقبوضًا من عميل.",
      "withCredit": "لا توجد سندات قبض برصيد غير مستخدم.",
      "void": "لا توجد سندات قبض ملغاة."
    },
    "views": {
      "label": "عروض سندات القبض",
      "all": "الكل",
      "withCredit": "برصيد غير مستخدم",
      "void": "الملغاة",
      "unapplied": "غير مستخدم",
      "received": "المستلم"
    },
    "stats": {
      "label": "أرقام سندات القبض",
      "received": "المقبوض",
      "unapplied": "رصيد غير مخصص",
      "unappliedDetail": "{{receipts}} للتخصيص أو الاسترداد",
      "unappliedShare": "{{percent}}٪ مما قُبض لم يُخصص بعد",
      "void": "الملغاة",
      "voidDetail": "ملغاة، لم يُقبض بها شيء",
      "receipts_zero": "لا سندات",
      "receipts_one": "سند واحد",
      "receipts_two": "سندان",
      "receipts_few": "{{n}} سندات",
      "receipts_many": "{{n}} سندًا",
      "receipts_other": "{{n}} سند"
    }
  },
  "statement": {
    "title": "كشف حساب عميل",
    "printedAt": "طُبع {{at}}",
    "invalidRange": "اختر تاريخ بداية قبل تاريخ النهاية.",
    "document": "المستند",
    "debit": "مدين",
    "credit": "دائن",
    "balance": "الرصيد",
    "opening": "الرصيد الافتتاحي",
    "closing": "الرصيد الختامي",
    "empty": "لا توجد حركات في هذه الفترة.",
    "hint": "من الدفاتر: الفواتير والإشعارات المدينة والمبالغ المستردة في الجانب المدين، وسندات القبض والإشعارات الدائنة في الجانب الدائن. الرصيد السالب يعني أن العميل له رصيد.",
    "source": {
      "SalesInvoice": "فاتورة",
      "Receipt": "سند قبض",
      "CreditNote": "إشعار دائن",
      "journal": "قيد يومية",
      "CustomerRefund": "مبلغ مسترد"
    },
    "totals": "مجاميع الفترة",
    "amountDue": "مبلغ مستحق",
    "inCredit": "له رصيد",
    "reversal": "قيد عكسي: أُبطِل المستند",
    "kind": {
      "INVOICE": "فاتورة",
      "DEBIT_NOTE": "إشعار مدين",
      "RECEIPT": "سند قبض",
      "CREDIT_NOTE": "إشعار دائن",
      "REFUND": "مبلغ مسترد",
      "OTHER": "قيد آخر"
    },
    "postings_zero": "لا قيود",
    "postings_one": "قيد واحد",
    "postings_two": "قيدان",
    "postings_few": "{{count}} قيود",
    "postings_many": "{{count}} قيدًا",
    "postings_other": "{{count}} قيد"
  },
  "aging": {
    "title": "أعمار الذمم المدينة",
    "subtitle": "ما على كل عميل حسب مدة تأخره، مخصومًا منه الرصيد غير المستخدم من سندات القبض والإشعارات الدائنة.",
    "asOf": "حتى {{date}}",
    "asOfLabel": "حتى تاريخ",
    "printedAt": "طُبع {{at}}",
    "searchLabel": "تصفية العملاء",
    "searchPlaceholder": "صفِّ حسب العميل…",
    "bucket": {
      "current": "غير مستحق",
      "days1to30": "1–30 يومًا",
      "days31to60": "31–60 يومًا",
      "days61to90": "61–90 يومًا",
      "over90": "أكثر من 90 يومًا"
    },
    "credit": "رصيد غير مستخدم",
    "total": "الرصيد",
    "totals": "الإجمالي",
    "empty": "لا يوجد عميل عليه مبالغ في هذا التاريخ.",
    "emptyBody": "تظهر هنا الفواتير المرحّلة ذات الأرصدة المفتوحة.",
    "hint": "تُحسب أيام التأخير من تاريخ استحقاق كل فاتورة. المبالغ المطبّقة بعد التاريخ لا تُحتسب بعد.",
    "summary": {
      "title": "الرصيد المستحق حسب العمر",
      "owed": "المستحق على العملاء",
      "customers_zero": "لا عملاء عليهم رصيد",
      "customers_one": "عميل واحد عليه رصيد",
      "customers_two": "عميلان عليهما رصيد",
      "customers_few": "{{count}} عملاء عليهم رصيد",
      "customers_many": "{{count}} عميلًا عليهم رصيد",
      "customers_other": "{{count}} عميل عليهم رصيد",
      "overdue": "متأخر السداد",
      "share": "{{share}} من الرصيد",
      "creditNote": "يُخصم من الرصيد",
      "bar": "أعمار الرصيد المستحق",
      "narrowed": "العملاء الذين عليهم رصيد في «{{column}}»",
      "showAll": "عرض الكل"
    }
  },
  "tillDocument": {
    "title": "صادر من نقطة البيع",
    "invoice": "صدرت هذه الفاتورة لعملية بيع في نقطة البيع، لذا لا تُبطَل من هنا. للتراجع عنها أبطِل عملية البيع من نقطة البيع ما دامت ورديتها مفتوحة.",
    "invoicePosOff": "صدرت هذه الفاتورة لعملية بيع في نقطة البيع، لذا لا تُبطَل من هنا. نقطة البيع متوقفة لشركتك: يمكن إبطال عملية البيع من نقطة البيع بعد إعادة تشغيلها.",
    "receipt": "هذا السند دفعة لعملية بيع في نقطة البيع، لذا لا يُبطَل من هنا. للتراجع عنه أبطِل عملية البيع من نقطة البيع ما دامت ورديتها مفتوحة.",
    "receiptPosOff": "هذا السند دفعة لعملية بيع في نقطة البيع، لذا لا يُبطَل من هنا. نقطة البيع متوقفة لشركتك: يمكن إبطال عملية البيع من نقطة البيع بعد إعادة تشغيلها.",
    "creditNote": "يسجّل هذا الإشعار الدائن بضاعة أُرجعت في نقطة البيع، لذا لا يُبطَل من هنا.",
    "returnTitle": "المرتجعات تمر عبر نقطة البيع",
    "returnPosOn": "بيعت هذه الفاتورة للعميل النقدي وهي مدفوعة. لا يحتفظ العميل النقدي برصيد، لذا لا يمكن ترحيل إشعار دائن عليها: تُرجَع البضاعة ويُردّ مبلغها في نقطة البيع.",
    "openTill": "افتح نقطة البيع",
    "returnPosOff": "بيعت هذه الفاتورة للعميل النقدي وهي مدفوعة. لا يحتفظ العميل النقدي برصيد، لذا تُرجَع البضاعة ويُردّ مبلغها في نقطة البيع. نقطة البيع متوقفة لشركتك: أعِد تشغيلها لإرجاع هذا البيع."
  },
  "project": {
    "field": "المشروع",
    "hint": "مشروع لهذا العميل تخصه هذه الإيرادات.",
    "chooseCustomerFirst": "اختر العميل أولًا.",
    "none": "دون مشروع",
    "placeholder": "اختر مشروعًا",
    "allowanceHint": "دون فاتورة: مشروع لهذا العميل. مع فاتورة يأخذ الإشعار مشروع الفاتورة.",
    "quotationHint": "أعمال إضافية لمشروع قائم: تحمل الفاتورة الناتجة عن تحويله المشروعَ.",
    "fromInvoice": "المشروع (من الفاتورة)",
    "issuedBy": "أصدرها المشروع {{code}}: تُلغى من المشروع.",
    "contractClaim": "فاتورة عقد: المستخلص {{claim}} للمشروع {{code}}.",
    "contractClaimPlain": "فاتورة عقد: مستخلص للمشروع {{code}}.",
    "contractAdvance": "فاتورة عقد: الدفعة المقدمة للمشروع {{code}}.",
    "contractRetention": "فاتورة عقد: إفراج عن محتجزات المشروع {{code}}.",
    "glRole": {
      "contract_revenue": "مستخلص",
      "customer_advances": "دفعة مقدمة",
      "retention_receivable": "محتجزات"
    },
    "glRoleHint": {
      "contract_revenue": "مستخلص معتمد (إيرادات العقود)",
      "customer_advances": "فاتورة دفعة مقدمة (دفعات مقدمة من العملاء)",
      "retention_receivable": "إفراج عن محتجزات (محتجزات لدى العملاء)"
    },
    "voidFromProject": "الإلغاء من المشروع",
    "voidThere": "اطلب ممن يستطيع فتح المشروع إلغاءها من تبويب الفوترة فيه.",
    "start": "بدء مشروع",
    "openStarted": "فتح المشروع {{code}}",
    "readyHint_zero": "لا بنود جاهزة للفوترة في {{code}} ({{total}}).",
    "readyHint_one": "في {{code}} بند واحد جاهز للفوترة ({{total}}). فوتره من تبويب الفوترة في المشروع ليُعلَّم مفوترًا.",
    "readyHint_two": "في {{code}} بندان جاهزان للفوترة ({{total}}). فوترهما من تبويب الفوترة في المشروع ليُعلَّما مفوترين.",
    "readyHint_few": "في {{code}} {{count}} بنود جاهزة للفوترة ({{total}}). فوترها من تبويب الفوترة في المشروع لتُعلَّم مفوترة.",
    "readyHint_many": "في {{code}} {{count}} بندًا جاهزًا للفوترة ({{total}}). فوترها من تبويب الفوترة في المشروع لتُعلَّم مفوترة.",
    "readyHint_other": "في {{code}} {{count}} بند جاهز للفوترة ({{total}}). فوترها من تبويب الفوترة في المشروع لتُعلَّم مفوترة.",
    "openBilling": "فتح فوترة {{code}}",
    "startedTitle": "بدأ عرض السعر هذا المشروع {{code}}",
    "startedBody": "يُفوتر من خطة فوترة المشروع، فلم يعد ممكنًا تحويله إلى فاتورة.",
    "correctThrough": {
      "contract_revenue": "تتم التصحيحات عبر المشروع: أبطِل آخر مستخلص أو عدّل المستخلص التالي.",
      "customer_advances": "تتم التصحيحات عبر المشروع: أبطِل الدفعة المقدمة هناك ما دامت لم تُسترد بأي شهادة.",
      "retention_receivable": "تتم التصحيحات عبر المشروع: أبطِل الإفراج هناك."
    }
  },
  "trail": {
    "project": "مشروع",
    "projectSlip": "المشروع {{code}}، {{name}}",
    "label": "مسار المستندات",
    "quotation": "عرض سعر",
    "tillSale": "عملية بيع (نقطة البيع)",
    "tillCompleted": "مكتمل",
    "tillVoid": "مُبطَل",
    "receipt": "سند قبض",
    "creditNote": "إشعار دائن",
    "journal": "قيد يومية",
    "settlements_zero": "سندات القبض والإشعارات الدائنة: لا مستندات",
    "settlements_one": "سندات القبض والإشعارات الدائنة: مستند واحد",
    "settlements_two": "سندات القبض والإشعارات الدائنة: مستندان",
    "settlements_few": "سندات القبض والإشعارات الدائنة: {{count}} مستندات",
    "settlements_many": "سندات القبض والإشعارات الدائنة: {{count}} مستندًا",
    "settlements_other": "سندات القبض والإشعارات الدائنة: {{count}} مستند",
    "more_zero": "+{{count}}",
    "more_one": "+ مستند آخر",
    "more_two": "+ مستندان آخران",
    "more_few": "+ {{count}} مستندات أخرى",
    "more_many": "+ {{count}} مستندًا آخر",
    "more_other": "+ {{count}} مستند آخر",
    "slip": "{{kind}} {{number}}، {{amount}}، {{status}}",
    "slipCurrent": "{{kind}} {{number}} (هذا المستند)، {{amount}}، {{status}}",
    "notApplied": "غير مستخدم",
    "slipNotApplied": "{{kind}} {{number}}، {{amount}}، {{status}}، لم يُطبّق على هذه الفاتورة",
    "reversedShort": "معكوس",
    "journalSpoken": "القيد {{number}}",
    "journalReversedSpoken": "القيد {{number}}، معكوس",
    "failed": "تعذّر تحميل بعض المستندات المرتبطة.",
    "retry": "إعادة المحاولة",
    "invoice": "فاتورة",
    "refund": "سند صرف",
    "invoices_zero": "الفواتير المسددة: لا مستندات",
    "invoices_one": "الفواتير المسددة: مستند واحد",
    "invoices_two": "الفواتير المسددة: مستندان",
    "invoices_few": "الفواتير المسددة: {{count}} مستندات",
    "invoices_many": "الفواتير المسددة: {{count}} مستندًا",
    "invoices_other": "الفواتير المسددة: {{count}} مستند",
    "refunds_zero": "الاستردادات: لا مستندات",
    "refunds_one": "الاستردادات: مستند واحد",
    "refunds_two": "الاستردادات: مستندان",
    "refunds_few": "الاستردادات: {{count}} مستندات",
    "refunds_many": "الاستردادات: {{count}} مستندًا",
    "refunds_other": "الاستردادات: {{count}} مستند",
    "sources_zero": "الرصيد المسترد: لا مستندات",
    "sources_one": "الرصيد المسترد: مستند واحد",
    "sources_two": "الرصيد المسترد: مستندان",
    "sources_few": "الرصيد المسترد: {{count}} مستندات",
    "sources_many": "الرصيد المسترد: {{count}} مستندًا",
    "sources_other": "الرصيد المسترد: {{count}} مستند",
    "settles_zero": "الفواتير المسددة والاستردادات: لا مستندات",
    "settles_one": "الفواتير المسددة والاستردادات: مستند واحد",
    "settles_two": "الفواتير المسددة والاستردادات: مستندان",
    "settles_few": "الفواتير المسددة والاستردادات: {{count}} مستندات",
    "settles_many": "الفواتير المسددة والاستردادات: {{count}} مستندًا",
    "settles_other": "الفواتير المسددة والاستردادات: {{count}} مستند",
    "slipApplied": "{{kind}} {{number}}، طُبّق {{amount}}",
    "receiptCount_zero": "لا سندات",
    "receiptCount_one": "سند واحد",
    "receiptCount_two": "سندان",
    "receiptCount_few": "{{count}} سندات",
    "receiptCount_many": "{{count}} سندًا",
    "receiptCount_other": "{{count}} سند",
    "receiptsSummary_zero": "لا سندات قبض، {{amount}}",
    "receiptsSummary_one": "سند قبض واحد، {{amount}}",
    "receiptsSummary_two": "سندا قبض، {{amount}}",
    "receiptsSummary_few": "{{count}} سندات قبض، {{amount}}",
    "receiptsSummary_many": "{{count}} سند قبض، {{amount}}",
    "receiptsSummary_other": "{{count}} سند قبض، {{amount}}"
  },
  "share": {
    "title": "مشاركة {{number}}",
    "body": "يستطيع أي شخص لديه الرابط رؤية هذه الفاتورة كما تُطبع، دون تسجيل الدخول.",
    "once": "يُعرض الرابط مرة واحدة فقط بعد إنشائه مباشرة. إلغاء الرابط يوقفه فورًا.",
    "expiry": "يتوقف الرابط عن العمل",
    "expiryHint": "بعدها يظهر لمن يفتحه «هذا الرابط غير متاح».",
    "never": "أبدًا",
    "days_zero": "بعد {{count}} يوم",
    "days_one": "بعد يوم واحد",
    "days_two": "بعد يومين",
    "days_few": "بعد {{count}} أيام",
    "days_many": "بعد {{count}} يومًا",
    "days_other": "بعد {{count}} يوم",
    "create": "إنشاء الرابط",
    "linkLabel": "رابط المشاركة",
    "copy": "نسخ",
    "copied": "نُسخ الرابط",
    "copiedShort": "نُسخ",
    "copyFailed": "تعذّر نسخ الرابط. حدّده وانسخه بـ Ctrl+C.",
    "open": "فتح",
    "onlyNow": "انسخه الآن: لن يُعرض مرة أخرى. لمشاركة الفاتورة لاحقًا، أنشئ رابطًا جديدًا.",
    "active": "الفاتورة مُشارَكة برابط",
    "created": "أُنشئ في",
    "expires": "يتوقف في",
    "lastOpened": "آخر فتح",
    "notOpened": "لم يُفتح بعد",
    "opened": "عدد مرات الفتح",
    "openedTimes_zero": "لم يُفتح",
    "openedTimes_one": "مرة واحدة",
    "openedTimes_two": "مرتان",
    "openedTimes_few": "{{n}} مرات",
    "openedTimes_many": "{{n}} مرة",
    "openedTimes_other": "{{n}} مرة",
    "revoke": "إلغاء الرابط",
    "replace": "إنشاء رابط جديد ونسخه",
    "revokeTitle": "إلغاء الرابط؟",
    "replaceTitle": "إنشاء رابط جديد؟",
    "revokeBody": "من لديه الرابط الحالي لن يتمكن من فتح الفاتورة بعد الآن.",
    "revoked": "أُلغي الرابط",
    "done": "تم",
    "wasRevoked": "أُلغي آخر رابط.",
    "wasExpired": "توقف آخر رابط عن العمل.",
    "onceActive": "لأسباب أمنية يُعرض الرابط مرة واحدة فقط عند إنشائه. لإرساله مرة أخرى، أنشئ رابطًا جديدًا: سيتوقف الرابط الحالي عن العمل.",
    "replaceBody": "سيتوقف الرابط الحالي عن العمل، ولن يتمكن من لديه من فتح الفاتورة. يُنسخ الرابط الجديد جاهزًا للإرسال.",
    "replaceConfirm": "إنشاء ونسخ",
    "replacedCopied": "نُسخ الرابط الجديد",
    "body_quotation": "يستطيع أي شخص لديه الرابط رؤية عرض السعر هذا كما يُطبع، دون تسجيل الدخول.",
    "onlyNow_quotation": "انسخه الآن: لن يُعرض مرة أخرى. لمشاركة عرض السعر لاحقًا، أنشئ رابطًا جديدًا.",
    "active_quotation": "عرض السعر مُشارَك برابط",
    "revokeBody_quotation": "من لديه الرابط الحالي لن يتمكن من فتح عرض السعر بعد الآن.",
    "replaceBody_quotation": "سيتوقف الرابط الحالي عن العمل، ولن يتمكن من لديه من فتح عرض السعر. يُنسخ الرابط الجديد جاهزًا للإرسال."
  },
  "applyCredit": {
    "title": "تطبيق رصيد على {{number}}",
    "body": "الرصيد المستحق {{amount}}. طبّق عليه رصيد العميل غير المستخدم.",
    "fill": "تعبئة الأقدم أولًا",
    "tableLabel": "رصيد العميل غير المستخدم",
    "source": "الرصيد",
    "available": "غير مستخدم",
    "apply": "المبلغ المطبّق",
    "applyFrom": "المبلغ المطبّق من {{number}}",
    "kind": {
      "RECEIPT": "سند قبض",
      "CREDIT_NOTE": "إشعار دائن"
    },
    "overSource": "أكبر من المتبقي فيه.",
    "applying": "المبلغ المطبّق",
    "left": "المتبقي للسداد",
    "overBalance": "مجموع المبالغ أكبر من الرصيد المستحق. خفّضها.",
    "confirm": "تطبيق الرصيد",
    "done": "طُبّق {{amount}} على {{number}}",
    "none": "لا يوجد رصيد غير مستخدم.",
    "noneBody": "ليس لهذا العميل سندات قبض أو إشعارات دائنة بقي فيها رصيد للتطبيق.",
    "truncated": "يظهر الرصيد الأقدم فقط. طبّقه، ثم افتح هذه النافذة مجددًا للباقي."
  },
  "public": {
    "unavailableTitle": "هذا الرابط غير متاح",
    "unavailableBody": "اطلب من المرسل رابطًا جديدًا لهذا المستند.",
    "failedTitle": "تعذّر تحميل المستند",
    "failedBody": "تحقّق من اتصالك ثم أعد المحاولة.",
    "retry": "إعادة المحاولة",
    "print": "طباعة",
    "language": "اللغة",
    "ready": "جاهز للطباعة"
  },
  "documents": {
    "open": "فتح",
    "print": "طباعة",
    "duplicate": "نسخ",
    "share": "مشاركة",
    "refund": "استرداد",
    "apply": "تطبيق",
    "remove": "إزالة",
    "applications": "الفواتير المسددة",
    "refunds": "الاستردادات منه",
    "unappliedNotice": "بقي فيه رصيد غير مستخدم: طبّقه على الفواتير المفتوحة أو ردّه للعميل.",
    "removeNamed_receipt": "إزالة {{invoice}} من سند القبض هذا",
    "removeNamed_creditNote": "إزالة {{invoice}} من هذا الإشعار الدائن",
    "removeTitle_receipt": "إزالة {{invoice}} من سند القبض هذا؟",
    "removeTitle_creditNote": "إزالة {{invoice}} من هذا الإشعار الدائن؟",
    "removed": "أُزيلت {{invoice}} من {{number}}",
    "creditStamp": "رصيد",
    "voucher": "سند القبض",
    "paymentVoucher": "سند الصرف",
    "noneVoid": "لا شيء مطبّق: المستند ملغى.",
    "figures": "الأرقام",
    "invoiceCount_zero": "لا فواتير",
    "invoiceCount_one": "فاتورة واحدة",
    "invoiceCount_two": "فاتورتان",
    "invoiceCount_few": "{{count}} فواتير",
    "invoiceCount_many": "{{count}} فاتورة",
    "invoiceCount_other": "{{count}} فاتورة",
    "sourceCount_zero": "من {{count}} رصيد",
    "sourceCount_one": "من رصيد واحد",
    "sourceCount_two": "من رصيدين",
    "sourceCount_few": "من {{count}} أرصدة",
    "sourceCount_many": "من {{count}} رصيدًا",
    "sourceCount_other": "من {{count}} رصيد",
    "onAccount": "رصيد دائن على الحساب",
    "fullyApplied": "مطبّق بالكامل",
    "voidRefundFirst": "ألغِ سند الصرف {{number}} المسحوب منه أولًا.",
    "voidRemoveFirst_zero": "أزل الفواتير أولًا.",
    "voidRemoveFirst_one": "أزل {{invoice}} أولًا.",
    "voidRemoveFirst_two": "أزل الفاتورتين أولًا.",
    "voidRemoveFirst_few": "أزل الفواتير الـ{{count}} أولًا.",
    "voidRemoveFirst_many": "أزل الفواتير الـ{{count}} أولًا.",
    "voidRemoveFirst_other": "أزل الفواتير الـ{{count}} أولًا.",
    "refundChequeNotCleared": "لم يصرف البنك الشيك {{number}} بعد: يمكن الاسترداد بعد صرفه.",
    "methodFilter": "تصفية حسب طريقة الدفع",
    "allMethods": "كل الطرق",
    "accountFilter": "تصفية حسب الحساب النقدي أو البنكي",
    "allAccounts": "كل الحسابات",
    "export": "تصدير",
    "exportHint_zero": "لا مستندات للتصدير",
    "exportHint_one": "يصدّر مستندًا واحدًا: هذا العرض بمرشحاته وترتيبه",
    "exportHint_two": "يصدّر مستندين: هذا العرض بمرشحاته وترتيبه",
    "exportHint_few": "يصدّر {{n}} مستندات: هذا العرض بمرشحاته وترتيبه",
    "exportHint_many": "يصدّر {{n}} مستندًا: هذا العرض بمرشحاته وترتيبه",
    "exportHint_other": "يصدّر {{n}} مستند: هذا العرض بمرشحاته وترتيبه",
    "exported_zero": "لم يُصدَّر أي مستند",
    "exported_one": "صُدِّر مستند واحد",
    "exported_two": "صُدِّر مستندان",
    "exported_few": "صُدِّرت {{n}} مستندات",
    "exported_many": "صُدِّر {{n}} مستندًا",
    "exported_other": "صُدِّر {{n}} مستند",
    "exportedView": "صُدِّر العرض",
    "rowActions": "إجراءات {{number}}",
    "lineCount_zero": "لا بنود",
    "lineCount_one": "بند واحد",
    "lineCount_two": "بندان",
    "lineCount_few": "{{count}} بنود",
    "lineCount_many": "{{count}} بندًا",
    "lineCount_other": "{{count}} بند",
    "voucherCard": "السند",
    "asPrinted": "كما يُطبع"
  },
  "voucher": {
    "receiptTitle": "سند قبض",
    "refundTitle": "سند صرف",
    "date": "التاريخ",
    "receivedFrom": "استلمنا من",
    "paidTo": "صرفنا إلى",
    "theSumOf": "مبلغ وقدره",
    "method": "طريقة الدفع",
    "intoAccount": "أُودع في",
    "fromAccount": "صُرف من",
    "reference": "رقم الشيك أو المرجع",
    "for": "وذلك عن",
    "refundOf": "وذلك استردادًا لـ",
    "onAccountOnly": "دفعة على الحساب",
    "onAccount": "رصيد دائن على الحساب",
    "more_zero": "+ لا مستندات أخرى",
    "more_one": "+ مستند آخر",
    "more_two": "+ مستندان آخران",
    "more_few": "+ {{count}} مستندات أخرى",
    "more_many": "+ {{count}} مستندًا آخر",
    "more_other": "+ {{count}} مستند آخر",
    "receivedBy": "المستلِم",
    "paidBy": "الصارف",
    "voidBanner": "ملغى — هذا السند لاغٍ",
    "inWords": "كتابةً",
    "paper": "الورق",
    "paperA5": "A5 أفقي (دفتر السندات)",
    "paperA4": "A4 عمودي"
  },
  "issuedPdf": {
    "title": "ملفات PDF الصادرة",
    "loading": "جارٍ تحميل ملفات PDF الصادرة…",
    "loadFailed": "تعذّر تحميل ملفات PDF الصادرة.",
    "empty": "لم يصدر ملف PDF بعد. أصدِر واحدًا لتحتفظ بنسخة مطابقة.",
    "emptyVoid": "لم يصدر ملف PDF لهذه الفاتورة.",
    "issueLegend": "إصدار PDF للفاتورة بحالتها الآن",
    "issue": {
      "en": "PDF (English)",
      "ar": "PDF (العربية)"
    },
    "language": {
      "en": "الإنجليزية",
      "ar": "العربية"
    },
    "version": "الإصدار {{version}}",
    "status": {
      "RENDERING": "قيد الإصدار",
      "ISSUED": "صادر",
      "FAILED": "لم يُنشأ",
      "PURGED": "حُذف الملف"
    },
    "failedNote": "تعذّر إنشاء ملف PDF هذا. أصدِره مرة أخرى.",
    "purgedNote": "حُذف الملف وفق سياسة الاحتفاظ بالبيانات، وبقيت بصمته الرقمية دليلًا.",
    "sha": "SHA-256",
    "copyHash": "نسخ بصمة SHA-256 للإصدار {{version}} ({{language}})",
    "hashCopied": "نُسخت بصمة SHA-256",
    "copyFailed": "تعذّر النسخ. حدّد الرمز وانسخه يدويًا.",
    "download": "تنزيل",
    "downloadNamed": "تنزيل الإصدار {{version}} ({{language}})",
    "downloadIssued": "تنزيل ملف PDF الصادر",
    "retry": "إعادة المحاولة",
    "vsPrint": "ملف PDF الصادر هو النسخة المطابقة لما سلّمته. أما الطباعة فتعرض الفاتورة بحالتها الآن.",
    "state": {
      "issuing": "جارٍ إصدار ملف PDF…",
      "rendering": "جارٍ تجهيز ملف PDF…",
      "slow": "ما زال ملف PDF قيد التجهيز، ويستغرق ذلك وقتًا أطول من المعتاد.",
      "done": "نُزّل ملف PDF.",
      "timeout": "ملف PDF غير جاهز بعد. حاول مرة أخرى بعد دقيقة.",
      "failed": "تعذّر إنشاء ملف PDF.",
      "purged": "حُذف ملف PDF هذا وفق سياسة الاحتفاظ بالبيانات."
    }
  },
  "email": {
    "send": "إرسال بالبريد الإلكتروني",
    "sendMenu": "إرسال بالبريد الإلكتروني…",
    "title": "إرسال الفاتورة {{number}} بالبريد الإلكتروني",
    "description": "يستلم العميل رسالة قصيرة مرفقًا بها الفاتورة بصيغة PDF.",
    "to": "إلى",
    "toHint": "اضغط Enter أو فاصلة بعد كل عنوان. حتى 5 عناوين.",
    "noCustomerEmail": "لا يوجد بريد إلكتروني مسجّل للعميل. اكتب عنوانًا.",
    "toRequired": "أضف عنوانًا واحدًا على الأقل.",
    "cc": "نسخة إلى (اختياري)",
    "ccHint": "تُرسل النسخ في رسائل منفصلة. حتى 5 عناوين.",
    "toList": "المستلمون",
    "ccList": "النسخ",
    "removeAddress": "إزالة {{address}}",
    "added": "أُضيف {{address}}. عدد العناوين: {{count}}.",
    "removed": "أُزيل {{address}}. عدد العناوين: {{count}}.",
    "invalidAddress": "عنوان بريد غير صالح. أزِله أو اكتبه من جديد.",
    "fixInvalid": "صحّح العناوين المعلّمة بالأحمر أو أزِلها.",
    "language": "لغة الرسالة وملف PDF",
    "languageHint": {
      "en": "الرسالة وملف PDF بالإنجليزية",
      "ar": "الرسالة وملف PDF بالعربية"
    },
    "languageName": {
      "en": "الإنجليزية",
      "ar": "العربية"
    },
    "note": "ملاحظة للعميل (اختياري)",
    "noteCount": "{{count}} من {{max}} حرفًا",
    "noteTooLong": "اجعل الملاحظة أقل من {{max}} حرفًا.",
    "notReadyTitle": "البريد الإلكتروني غير مُعد لهذه الشركة",
    "notReadyAdmin": "اضبط طريقة إرسال البريد من الإعدادات، ثم عُد لإرسالها.",
    "notReadyAsk": "اطلب من المسؤول إعداد البريد الإلكتروني من الإعدادات.",
    "openSettings": "فتح إعدادات البريد",
    "sendFailed": "لم تُرسل الرسالة",
    "cancel": "إلغاء",
    "close": "إغلاق",
    "sendAgain": "إرسال مرة أخرى",
    "steps": "مراحل الإرسال",
    "step": {
      "issuing": "إصدار PDF",
      "queued": "في الانتظار",
      "sent": "أُرسلت"
    },
    "overall": {
      "issuing": "جارٍ إصدار ملف PDF…",
      "queued": "في الانتظار، وستُرسل بعد لحظات.",
      "sent": "أُرسلت.",
      "partly": "أُرسلت إلى بعض المستلمين فقط.",
      "notSent": "لم تُرسل."
    },
    "status": {
      "QUEUED": "في الانتظار",
      "SENDING": "قيد الإرسال",
      "SENT": "أُرسلت",
      "FAILED": "لم تُرسل",
      "SUPPRESSED": "موقوفة"
    },
    "stillQueued": "ما زالت في الانتظار. قد يستغرق الإرسال بضع دقائق.",
    "refresh": "تحديث",
    "openOutbox": "فتح صندوق الصادر",
    "retryLoad": "إعادة المحاولة",
    "preview": {
      "title": "معاينة",
      "subjectLabel": "الموضوع:",
      "subject": "الفاتورة {{number}} من {{company}}",
      "invoiceDate": "تاريخ الفاتورة",
      "dueDate": "تاريخ الاستحقاق",
      "total": "الإجمالي",
      "balance": "الرصيد المستحق",
      "currency": "ر.ع.",
      "attachment": "المرفق:",
      "wording": "تأتي الصياغة الدقيقة من قالب البريد الخاص بشركتك."
    },
    "panel": {
      "title": "رسائل البريد",
      "loading": "جارٍ تحميل الرسائل…",
      "loadFailed": "تعذّر تحميل الرسائل.",
      "empty": "لم تُرسل أي رسالة بعد.",
      "recipientRemoved": "أُزيل العنوان",
      "retry": "إعادة الإرسال",
      "retryNamed": "إعادة إرسال الرسالة إلى {{address}}",
      "retried": "أُعيدت إلى قائمة الانتظار.",
      "retryFailed": "تعذّرت إعادة إرسال هذه الرسالة."
    },
    "recipientLimit": "حتى {{max}} عناوين. أزِل عنوانًا لإضافة غيره.",
    "notAdded": "لم يُضف: {{count}} إضافية (الحد {{max}})."
  },
  "salesperson": {
    "label": "مندوب المبيعات",
    "hint": "يُنسب إليه البيع في احتساب العمولة.",
    "customerDefault": "مندوب مبيعات العميل",
    "none": "بلا مندوب",
    "placeholder": "اختر مندوب المبيعات",
    "search": "ابحث عن شخص",
    "empty": "لم يُعثر على أحد",
    "error": "تعذّر تحميل الأشخاص",
    "quotationHint": "ينتقل إلى الفاتورة التي يتحول إليها.",
    "creditNoteHint": "من تنقص عمولته بهذا الإشعار.",
    "fromInvoice": "مندوب المبيعات، من الفاتورة:",
    "mine": "مبيعاتي",
    "filter": "مندوب المبيعات",
    "all": "كل المندوبين",
    "chosen": "المندوب المختار"
  }
}
